module.exports = __webpack_public_path__ + "static/media/life.55a4a619.svg";